<template>
  <div class="progressPlan">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px">进度计划</span>
        <div class="head-text" style="float: right; margin-top: -4px">
          <!-- 新建事件 -->
          <el-input
            v-model="query"
            placeholder="请输入进度计划名称"
            class="search-input"
          ></el-input>
          <el-button
            slot="append"
            icon="el-icon-search"
            style="margin-right: 80px"
            @click="GetPlanList"
          ></el-button>
          <el-button
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('10321')) ||
              $store.state.isProject
            "
            type="primary"
            @click="dialogVisibleOpen"
            >新增</el-button
          >
          <el-button type="primary" @click="CopyPlan">复制</el-button>
          <el-button
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('10322')) ||
              $store.state.isProject
            "
            type="danger"
            @click="DelPlan"
            >删除</el-button
          >
        </div>
      </div>

      <el-table
        :data="pjplList"
        height="72vh"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
      >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
          type="index"
          align="center"
          label="排序"
          width="50"
        ></el-table-column>
        <el-table-column
          label="计划名称"
          align="center"
          prop="pjpl03"
        ></el-table-column>
        <el-table-column prop="pjpl04" align="center" label="类型">
          <template slot-scope="scope">{{
            scope.row.pjpl04 == 1 ? "新建" : "拆除"
          }}</template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="完成进度">
          <template slot-scope="scope">
            <el-progress
              :text-inside="true"
              :stroke-width="24"
              :percentage="scope.row.wcjd.toFixed(2)"
              status="success"
            ></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="pjpl05" align="center" label="重要程度">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.pjpl05" disabled></el-rate>
          </template>
        </el-table-column>
        <el-table-column
          prop="pjpl10"
          align="center"
          label="责任人员"
        ></el-table-column>
        <el-table-column
          prop="pjpl06"
          align="center"
          label="备注"
        ></el-table-column>
        <el-table-column
          prop="user04"
          align="center"
          label="创建人"
        ></el-table-column>
        <el-table-column prop="pjpl09" align="center" label="可见范围">
          <template slot-scope="scope">{{
            scope.row.pjpl09 == 1 ? "公开" : "半公开"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="pjpl08N"
          align="center"
          label="创建时间"
        ></el-table-column>
        <el-table-column min-width="140" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              plain
              @click="seeConstruction(scope.row)"
              >查看</el-button
            >
            <el-button
              type="primary"
              plain
              size="small"
              @click="dialogVisible2Show(scope.row)"
              >编辑</el-button
            >
            <el-button
              :type="scope.row.pjpl12 ? 'info' : 'primary'"
              plain
              @click="topplan(scope.row)"
              size="small"
              >{{ scope.row.pjpl12 ? "取消置顶" : "置顶" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 30px"
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 新增 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增进度计划"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-row>
        <el-col :span="10">
          <el-form ref="form" :model="pjpl" label-width="80px">
            <el-form-item label="计划名称">
              <el-input v-model="pjpl.pjpl03"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select filterable v-model="pjpl.pjpl04">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in options"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="重要程度">
              <el-rate v-model="pjpl.pjpl05"></el-rate>
            </el-form-item>
            <el-form-item label="责任人员">
              <el-input v-model="pjpl.pjpl10"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="pjpl.pjpl06"></el-input>
            </el-form-item>
            <el-form-item label="选择模型">
              <el-select
                filterable
                multiple
                v-model="pjpl.pjpl11"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in ModelList"
                  :key="item.mode01"
                  :label="item.mode02"
                  :value="item.mode01"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" :offset="1">
          可见设置：
          <el-radio v-model="pjpl.pjpl09" :label="1">公开</el-radio>
          <el-radio v-model="pjpl.pjpl09" :label="2">半公开</el-radio>
          <div
            style="
              border: 2px solid #eee;
              height: 200px;
              width: 80%;
              padding: 10px;
              margin: 10px;
              box-sizing: border-box;
            "
            v-if="pjpl.pjpl09 == 2"
          >
            <el-row>
              <el-col
                :span="12"
                v-for="(item, index) in multipleSelectionList2"
                :key="index"
              >
                {{ item.user04 }}
                <span
                  style="color: red; cursor: pointer"
                  @click="delectUser(index)"
                  >x</span
                >
              </el-col>
            </el-row>
          </div>
          <el-button
            type="primary"
            style="margin: 10px"
            v-if="pjpl.pjpl09 == 2"
            @click="dialogVisible1OPen"
            >添加</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3" :offset="8">
          <el-button style="width: 100%" @click="submitDdd">确定</el-button>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button style="width: 100%" @click="dialogVisible = false"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 新建人员列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="请选择人员"
      :visible.sync="dialogVisible1"
      width="25%"
    >
      <el-input
        placeholder="请输入人员名称"
        v-model="GetPlanUserSearchWord"
        style="width: 80%"
      ></el-input>
      <el-button icon="el-icon-search" @click="GetPlanUser"></el-button>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        @selection-change="handleSelectionChange2"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="100px"
        ></el-table-column>
        <el-table-column prop="user02" label="账号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <div
        style="
          width: 100%;
          padding: 10px;
          display: flex;
          justify-content: center;
        "
      >
        <el-button type="primary" size="small" @click="dialogVisible1 = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑人员列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="请选择人员"
      :visible.sync="dialogVisible3"
      width="25%"
    >
      <el-input
        placeholder="请输入人员名称"
        v-model="GetPlanUserSearchWord"
        style="width: 80%"
      ></el-input>
      <el-button icon="el-icon-search" @click="GetPlanUser"></el-button>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        @selection-change="handleSelectionChange2"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="100px"
        ></el-table-column>
        <el-table-column prop="user02" label="账号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <div
        style="
          width: 100%;
          margin-top: 10px;
          display: flex;
          justify-content: center;
        "
      >
        <el-button type="primary" size="small" @click="addUser">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      :visible.sync="dialogVisible2"
      width="40%"
    >
      <el-row>
        <el-col :span="10">
          <el-form ref="form" :model="pjpl" label-width="80px">
            <el-form-item label="计划名称">
              <el-input v-model="pjpl.pjpl03"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select filterable v-model="pjpl.pjpl04">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in options"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="重要程度">
              <el-rate v-model="pjpl.pjpl05"></el-rate>
            </el-form-item>
            <el-form-item label="责任人员">
              <el-input v-model="pjpl.pjpl10"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="pjpl.pjpl06"></el-input>
            </el-form-item>
            <el-form-item label="已选模型">
              <el-input
                type="textarea"
                v-model="pjpl.mode02"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="添加模型">
              <el-select
                filterable
                multiple
                v-model="pjpl.addModel"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in ModelList"
                  :key="item.mode01"
                  :label="item.mode02"
                  :value="item.mode01"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" :offset="2">
          可见设置：
          <el-radio @change="radioChange" v-model="pjpl.pjpl09" :label="1"
            >公开</el-radio
          >
          <el-radio v-model="pjpl.pjpl09" :label="2">半公开</el-radio>
          <div
            style="
              border: 2px solid #eee;
              height: 200px;
              width: 80%;
              padding: 10px;
              margin: 10px;
              box-sizing: border-box;
            "
            v-if="pjpl.pjpl09 == 2"
          >
            <el-row>
              <el-col
                :span="12"
                v-for="(item, index) in multipleSelectionList2"
                :key="index"
              >
                {{ item.user04 }}
                <span
                  style="color: red; cursor: pointer"
                  @click="delectUser2(item)"
                  >x</span
                >
              </el-col>
            </el-row>
          </div>
          <el-button
            type="primary"
            style="margin: 10px"
            v-if="pjpl.pjpl09 == 2"
            @click="dialogVisible1OPen2"
            >添加</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3" :offset="8">
          <el-button style="width: 100%" @click="submitDdd2">确定</el-button>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button style="width: 100%" @click="dialogVisible2 = false"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPlanUser,
  UpdatePlan,
  GetPlanList,
  GetPlanOne,
  DelPlanUser,
  AddPlanUser,
  GetProjectModelList,
  DelPlan,
  CopyPlan,
  TopPlan,
} from "@/setAxios";
export default {
  name: "progressPlan",
  data() {
    return {
      GetPlanUserSearchWord: "",
      planid: "",
      ids: localStorage.getItem("id"),
      pjpl: {
        pjpl01: 0,
        pjpl02: localStorage.xid,
        pjpl03: "",
        pjpl04: "",
        pjpl05: 0,
        pjpl06: "",
        pjpl07: localStorage.id,
        pjpl09: 1,
        pjpl10: "",
        pjpl11: "",
        userList: null,
      },
      options: [
        { label: "新建", value: 1 },
        { label: "拆除", value: 2 },
      ],
      tableData: [],
      pjplList: [],
      tableLoading: false,
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      radio: 1,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      multipleSelection: [],
      multipleSelection2: [], //选择列表
      multipleSelectionList2: [], //显示列表
      ModelList: [],
      query: "",
    };
  },
  created() {
    this.GetPlanList();
  },
  methods: {
    topplan(data) {
      TopPlan({ id: data.pjpl01 }).then((res) => {
        this.$message.success("修改成功");
        this.GetPlanList();
      });
    },
    CopyPlan() {
      let ids = "",
        _split = "";
      this.multipleSelection.forEach((ele) => {
        ids += _split + ele.pjpl01;
        _split = ",";
      });
      if (ids == "" || ids.length <= 0) {
        this.$message({
          type: "warning",
          message: "未选择任何项！",
        });
        return;
      }
      this.$confirm("是否复制所选进度管理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          CopyPlan({ ids }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "复制成功",
              });
              this.GetPlanList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复制",
          });
        });
    },
    DelPlan() {
      let ids = "",
        _split = "";
      this.multipleSelection.forEach((ele) => {
        ids += _split + ele.pjpl01;
        _split = ",";
      });
      this.$confirm("是否删除所选进度管理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelPlan({ ids }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.GetPlanList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    seeConstruction(row) {
      var code = `planid=${row.pjpl01}&modelId=${row.pjpl11}&userId=${row.pjpl07}`;
      code = Base64.encode(code);
      this.$router.push({
        path: "/constructionSchedule",
        query: {
          code,
        },
      });
    },
    radioChange() {
      this.pjpl.userList = null;
    },
    dialogVisibleOpen() {
      this.dialogVisible = true;
      this.pjpl = {
        pjpl01: 0,
        pjpl02: localStorage.xid,
        pjpl03: "",
        pjpl04: "",
        pjpl05: 0,
        pjpl06: "",
        pjpl07: localStorage.id,
        pjpl09: 1,
        pjpl10: "",
        pjpl11: "",
        userList: null,
      };
      let params = {
        xid: this.$store.state.xid,
        seachword: "",
        pageIndex: 1,
        pageSize: 100000,
      };
      GetProjectModelList({ params }).then((res) => {
        this.ModelList = res.Data.list;
      });
      this.multipleSelection2 = this.multipleSelectionList2 = [];
    },
    addUser() {
      if (this.multipleSelection2.length == 0) {
        this.$message.error("请选择人员");
        return;
      }
      let params = [];
      this.multipleSelection2.forEach((ele) => {
        let params1 = {
          plvs02: localStorage.xid,
          plvs03: this.planid,
          plvs04: "",
        };
        params1.plvs04 = ele.user01;
        params.push(params1);
      });
      let model = JSON.stringify(this.pjpl);
      UpdatePlan({ model }).then((res1) => {
        AddPlanUser(params).then((res) => {
          if (res.Code > 0) {
            this.dialogVisible3 = false;
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.GetPlanList();
            this.GetPlanOne();
          }
        });
      });
    },
    dialogVisible2Show(row) {
      this.dialogVisible2 = true;
      this.planid = row.pjpl01;
      this.GetPlanOne();
    },
    async GetPlanOne() {
      let params = {
        xid: this.$store.state.xid,
        seachword: "",
        pageIndex: 1,
        pageSize: 100000,
      };
      let res = await GetProjectModelList({ params });
      this.ModelList = res.Data.list;

      params = {
        planid: this.planid,
      };
      res = await GetPlanOne(params);
      this.pjpl = res.Data;
      let mids = res.Data.pjpl11.split(",").map(Number);
      this.ModelList = this.ModelList.filter((x) => !mids.includes(x.mode01));
      this.multipleSelectionList2 = res.Data.userList;
    },
    // 获取项目计划
    GetPlanList() {
      let params = {
        xid: this.$store.state.xid,
        userid: localStorage.getItem("id"),
        searchword: this.query,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.tableLoading = true;
      GetPlanList(params).then((res) => {
        this.tableLoading = false;
        if (res.Data) {
          this.pjplList = res.Data.list;
          this.total = res.Data.total;
        }
      });
    },
    // 添加
    submitDdd() {
      this.pjpl.pjpl11 = this.pjpl.pjpl11.join(",");
      let params = JSON.stringify(this.pjpl);
      UpdatePlan({ model: params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.dialogVisible = false;
          this.GetPlanList();
        }
      });
    },
    submitDdd2() {
      if (this.pjpl.addModel.length)
        this.pjpl.pjpl11 += "," + this.pjpl.addModel.join(",");
      let params = JSON.stringify(this.pjpl);
      UpdatePlan({ model: params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.dialogVisible2 = false;
          this.GetPlanList();
        }
      });
    },
    delectUser(index) {
      this.multipleSelection2.splice(index, 1);
      this.$message({
        type: "success",
        message: "删除成功",
      });
    },
    // 删除人员
    delectUser2(data) {
      //(data);
      let params = {
        userid: data.user01,
        planid: this.planid,
      };
      DelPlanUser(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.GetPlanOne();
        }
      });
    },
    dialogVisible1OPen() {
      this.dialogVisible1 = true;
      this.GetPlanUser();
    },
    GetPlanUser() {
      let params = {
        searchword: this.GetPlanUserSearchWord,
        userid: localStorage.id,
        xid: localStorage.xid,
        planid: 0,
      };
      GetPlanUser({ ...params }).then((res) => {
        this.tableData = res.Data;
      });
    },
    dialogVisible1OPen2() {
      this.dialogVisible3 = true;
      let params = {
        userid: localStorage.id,
        xid: localStorage.xid,
        planid: this.planid,
      };
      GetPlanUser({ ...params }).then((res) => {
        this.tableData = res.Data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      this.pjpl.userList = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetPlanList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetPlanList();
    },
  },
};
</script>

<style lang="less" scoped>
.search-input {
  width: 300px;
}
</style>
